<template>
  <v-card class="ex-toolbar-product py-2 px-4" color="#282732" v-if="show_toolbar">
    <div class="d-flex align-center">
      <v-btn
        text
        :ripple="false"
        class="ma-0 mr-1 ex-btn ex-opacity-btn square-btn px-0"
        @click="productPrevious()"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-btn
        text
        :ripple="false"
        class="ma-0 mr-1 ex-btn ex-opacity-btn square-btn px-0"
        @click="productForward()"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <!-- <v-btn
        text
        outlined
        :ripple="false"
        :disabled="disabled"
        class="my-0 me-1"
        @click="openMoveDialog()"
      >
        <v-icon class="mr-2">low_priority</v-icon> move
      </v-btn> -->
      <v-speed-dial
        open-on-hover
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn
            color="blue darken-3"
            dark
            class="ma-0 mr-1 ex-btn ex-opacity-btn square-btn px-0"
            :disabled="disabled"
          >
            <v-icon >
              menu
            </v-icon>
            <!-- <v-icon v-else>
              mdi-account-circle
            </v-icon> -->
          </v-btn>
        </template>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
           <v-btn
              fab
              dark
              small
              color="green"
              :disabled="disabled"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>merge_type</v-icon>
            </v-btn>
          </template>
          <span>Merge</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              dark
              small
              color="indigo"
              @click.stop="openMoveDialog()"
              :disabled="disabled"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>send</v-icon>
            </v-btn>
        </template>
          <span>Move</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              dark
              small
              color="red"
              :disabled="disabled"
              @click="openMassiveDeleteDialog"
              v-bind="attrs"
                  v-on="on"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
        </template>
          <span>Delete</span>
        </v-tooltip>
      </v-speed-dial>
      <v-btn
        text
        :ripple="false"
        :disabled="!loaded_products.length"
        class="ma-0 ex-btn ex-primary-btn"
        @click.stop="openDialog()"
      >
        <v-icon class="mr-2">vertical_split</v-icon> All Products
      </v-btn>
      <div class="d-flex flex-column ml-3 body-2">
        <span class="my-0" v-if="filter.selected_status === 0">
          Pending: {{ loaded_products.filter(p => p.status === 0).length }}
        </span>
        <span class="my-0" v-if="filter.selected_status === 1">
          ReChecks: {{ loaded_products.filter(p => p.status === 1).length }}
        </span>
        <span class="my-0" v-if="filter.selected_status === 2">
          Completed: {{ loaded_products.filter(p => p.status === 2).length }}
        </span>
        <span class="my-0">
          Total: {{ loaded_products.length }}
        </span>
      </div>
    </div>
    <v-progress-linear
      v-if="typeof filter.selected_status === 'number'"
      color="red"
      :value="(100 - (loaded_products.filter(p => p.status === filter.selected_status).length / loaded_products.length) * 100)"
      class="mt-1 mb-0"
    ></v-progress-linear>
  </v-card>
</template>

<script>
/* eslint-disable */
import { productionBus } from "@/helpers/buses";

export default {
  name: "N_Toolbar",
  props: {
    // searchData: {
    //   type: [Object, Array],
    //   default: null
    // }
  },
  data: () => ({
    dataOfClientsID: 0,
    valid_route_names: ["product-table", "production"],
  }),
  methods: {
    openMoveDialog() {
      this.$emit("moveUrls");
    },
    openDialog() {
      this.$emit("showProductList");
      // this.searchData.dialogData.show = true
    },
    openMassiveDeleteDialog() {
      productionBus.$emit('open_massive_delete_dialog')
    },
    productPrevious() {
      console.log("Previous");
      const previous_product_id =
        this.loaded_products.at(
          this.current_product_index - 1
        ).product_id;
      console.log("test prev", previous_product_id);
      productionBus.$emit('clear_add_urls');
      this.$emit("go_to_product_id", previous_product_id );
    },
    productForward() {
      console.log("Forward");
      const next_product_id =
        this.loaded_products.at(
          (this.current_product_index + 1) % this.loaded_products.length
        ).product_id; // modulo for not go outside products length
      console.log("test next", next_product_id);
      productionBus.$emit('clear_add_urls');
      this.$emit("go_to_product_id", next_product_id );
    },
    // selectedClient (clientId) {
    //   this.$emit('clientInfo', clientId)
    // },
    handleKeys () {
      const isTextField = event.target.tagName.toLowerCase() === 'input';
      if(event.code === 'ArrowLeft') {
        if(!isTextField){
          this.productForward();
        }
      }
      else if(event.code === 'ArrowRight') {
        if(!isTextField){
          this.productPrevious();
        }
      }
    },
  },
  computed: {
    selectedClient() {
      return this.$store.state.productionModule.product_filter.selected_client;
    },
    loaded_products() {
      return this.$store.state.productionModule.loaded_products;
    },
    // loaded_products.length() {
    //   return this.$store.state.productionModule.loaded_products.length;
    // },
    selected_urls_count() {
      return this.$store.state.productionModule.selected_urls_of_product.length;
    },
    current_product_index() {
      return this.$store.state.productionModule.loaded_products.findIndex(
        (p) =>
          p.product_id == this.$store.state.productionModule.selected_product.id
      );
    },
    show_toolbar() {
      return this.valid_route_names.includes(this.$route.name);
      // return this.$route.name === "production";
    },
    disabled() {
      return !this.loaded_products.length || !this.selected_urls_count;
    },
    filter() {
      return this.$store.state.productionModule.product_filter
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeys)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeys)
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_Toolbar.vue